import { Button, styled } from '@project44/manifest-ds';

import cube from '../../assets/glass.png';

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
  backgroundColor: '$palette-grey-900',
  backgroundImage: `url(${cube})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'bottom left',
  padding: '95px 50px',
});

export const LearnMoreButton = styled(Button, {
  borderRadius: '70px',
  padding: '0 30px',
});
